import { render, staticRenderFns } from "./ExperienceText.vue?vue&type=template&id=202f3288"
import script from "./ExperienceText.vue?vue&type=script&lang=js"
export * from "./ExperienceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports